export default "__VITE_ASSET__CxiHFX7Y__"